import React from 'react'

export default function GreenUnderline() {
  return (
    <span className="absolute left-1/2 bottom-0 lg:-bottom-6 transform -translate-x-1/2 w-2/5 h-1 bg-green-500 transition-transform duration-300 origin-left"></span>
  )
}
